import React from "react";
import { Button, Glyphicon, ListGroupItem } from "react-bootstrap";

const ParticipantListItem = (
    {
        item,
        onDelete,
    }
) => {
    return (
        <ListGroupItem
            style={{
                padding: '4px 4px 4px 20px',
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <h4 style={{fontSize: '14px'}}>
                {item.titleRu ?? item.titleEn}
            </h4>
            <Button onClick={() => onDelete(item.id)}>
                <Glyphicon glyph="trash" />
            </Button>
        </ListGroupItem>
    )
};

export default ParticipantListItem;
